import { isValidDomain } from '@wix/domains-serverless-interface';
const DEFAULT_SITE_NAME_PATTERN = /^(mysite|website|newsite|fromtemplate|astro|hopp)\d*$/;
const NON_DOMAIN_CHARS = /[^a-z\d-]/g;
const EDGE_HYPHENS = /^-+|-+$/g;
export const isDefaultSiteName = siteName => {
  const trimmedName = (siteName == null ? void 0 : siteName.trim()) ?? '';
  const alphanumericName = trimmedName.toLowerCase().replace(/[^a-z\d]/g, '');
  return !trimmedName || DEFAULT_SITE_NAME_PATTERN.test(alphanumericName);
};
export const resolveSitenameBi = siteName => {
  const isGeneric = isDefaultSiteName(siteName);
  return {
    sitename: isGeneric ? undefined : siteName == null ? void 0 : siteName.trim(),
    sitenameType: isGeneric ? 'generic' : 'custom'
  };
};
export const buildDomainFromSiteName = (siteName, tld) => {
  const sld = (siteName ?? '').toLowerCase().replace(NON_DOMAIN_CHARS, '').replace(EDGE_HYPHENS, '');
  const domain = `${sld}.${tld}`;
  return sld && tld && isValidDomain(domain) ? domain : undefined;
};
//# sourceMappingURL=siteName.js.map